(() => {
  const state = { registration: '', make: '', model: '', derivative: '', generation: '', year: '', vin: '', part_number: '' };

  function normaliseRegistration(value) {
    return String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 8);
  }

  function prettyRegistration(value) {
    const reg = normaliseRegistration(value);
    if (reg.length > 4) return `${reg.slice(0, -3)} ${reg.slice(-3)}`;
    return reg;
  }

  function firstValue(...values) {
    return values.find((value) => value !== undefined && value !== null && String(value).trim() !== '') || '';
  }

  function normaliseApiResponse(payload, registration) {
const source = payload?.vehicle || payload?.result?.vehicle_identification || payload?.vehicle_identification || payload?.result || payload || {};
    const year = firstValue(source.manufactured_year, source.year, source.year_of_manufacture);
    return {
      registration: normaliseRegistration(firstValue(source.vehicle_registration_mark, source.registration, registration)),
      make: String(firstValue(source.dvla_manufacturer_desc, source.make, source.manufacturer)).trim(),
      model: String(firstValue(source.dvla_model_desc, source.model)).trim(),
      derivative: String(firstValue(source.dvla_model_desc, source.derivative, source.trim)).trim(),
      generation: String(firstValue(source.generation, source.model_generation)).trim(),
      year: String(year || '').trim(),
      vin: String(firstValue(source.vehicle_identification_number, source.vin)).trim().toUpperCase(),
      part_number: ''
    };
  }

  function isTesla(make) {
    return /^TESLA(?:\s|$)/i.test(String(make || '').trim());
  }

  const teslaMessage = 'Tesla sensors currently unavailable. KYVO Automotive does not currently supply TPMS sensors compatible with Tesla vehicles. We are working to expand our range.';

  function clearSelectedVehicle() {
    Object.keys(state).forEach((key) => { state[key] = ''; });
    document.querySelectorAll('[data-selected-vehicle]').forEach((el) => { el.textContent = 'Vehicle not selected yet'; });
    document.querySelectorAll('[data-line-property]').forEach((input) => { input.value = ''; });
  }

  function updateVehicleAcrossPage(vehicle) {
    Object.assign(state, vehicle);
    document.querySelectorAll('[data-selected-vehicle]').forEach((el) => {
      const parts = [vehicle.make, vehicle.model, vehicle.year].filter(Boolean);
      el.textContent = parts.length ? parts.join(' ') : 'Vehicle not selected yet';
    });
    document.querySelectorAll('[data-line-property]').forEach((input) => {
      const key = input.getAttribute('data-line-property');
      input.value = vehicle[key] || '';
    });
  }

  function setStatus(root, message, type = '') {
    const status = root.querySelector('[data-vrm-status]');
    if (!status) return;
    status.className = `kyvo-vrm-status${type ? ` is-${type}` : ''}`;
    status.textContent = message;
  }

  async function lookupVehicle(root, registration) {
    const endpoint = root.getAttribute('data-vrm-endpoint');
    if (!endpoint) return null;
    const url = new URL(endpoint, window.location.origin);
    url.searchParams.set('vrm', registration);
    const response = await fetch(url.toString(), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    });
    let data = null;
    try { data = await response.json(); } catch (_) {}
    if (!response.ok) throw new Error(data?.error || 'Vehicle lookup failed');
    return data;
  }

  document.querySelectorAll('[data-vrm-section]').forEach((root) => {
    const form = root.querySelector('[data-vrm-form]');
    const regInput = root.querySelector('[data-vrm-input]');
    const submitButton = form?.querySelector('button[type="submit"]');
    const manualButton = root.querySelector('[data-manual-toggle]');
    const manualPanel = root.querySelector('[data-manual-panel]');
    const manualForm = root.querySelector('[data-manual-form]');
    const confirmPanel = root.querySelector('[data-vrm-confirm]');
    const confirmTitle = root.querySelector('[data-vrm-confirm-title]');
    const confirmMeta = root.querySelector('[data-vrm-confirm-meta]');
    const confirmYes = root.querySelector('[data-vrm-confirm-yes]');
    const confirmNo = root.querySelector('[data-vrm-confirm-no]');
    let pendingVehicle = null;

    const openManual = () => {
      if (!manualPanel) return;
      confirmPanel?.setAttribute('hidden', '');
      root.querySelector('[data-tesla-unavailable]')?.setAttribute('hidden', '');
      manualPanel.classList.add('is-open');
      manualPanel.querySelector('input')?.focus();
    };

    const resetLookup = () => {
      pendingVehicle = null;
      root.querySelector('[data-tesla-unavailable]')?.setAttribute('hidden', '');
      confirmPanel?.setAttribute('hidden', '');
      setStatus(root, '');
      if (regInput) {
        regInput.removeAttribute('disabled');
        regInput.focus();
        regInput.select();
      }
      if (submitButton) submitButton.disabled = false;
    };

    manualButton?.addEventListener('click', openManual);
    confirmNo?.addEventListener('click', resetLookup);
    confirmYes?.addEventListener('click', () => {
      if (!pendingVehicle || isTesla(pendingVehicle.make)) return;
      updateVehicleAcrossPage(pendingVehicle);
      confirmPanel?.setAttribute('hidden', '');
      manualPanel?.classList.remove('is-open');
      setStatus(root, `Vehicle confirmed: ${[pendingVehicle.make, pendingVehicle.model, pendingVehicle.year].filter(Boolean).join(' ')}`, 'success');
      document.querySelector('#kyvo-product')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const registration = normaliseRegistration(regInput?.value);
      if (registration.length < 5) {
        setStatus(root, 'Please enter a valid UK registration.', 'error');
        return;
      }
      if (regInput) regInput.value = prettyRegistration(registration);
      pendingVehicle = null;
      root.querySelector('[data-tesla-unavailable]')?.setAttribute('hidden', '');
      confirmPanel?.setAttribute('hidden', '');
      manualPanel?.classList.remove('is-open');
      setStatus(root, 'Checking your vehicle…');
      if (submitButton) submitButton.disabled = true;

      try {
        const data = await lookupVehicle(root, registration);
        if (!data) {
          state.registration = registration;
          document.querySelectorAll('[data-line-property="registration"]').forEach((input) => input.value = registration);
          setStatus(root, 'Registration lookup is not connected yet. Please enter the vehicle manually below.', 'error');
          openManual();
          return;
        }
        const vehicle = normaliseApiResponse(data, registration);
        if (!vehicle.make || !vehicle.model || !vehicle.year) throw new Error('Incomplete vehicle data');
        if (isTesla(vehicle.make)) {
          clearSelectedVehicle();
          pendingVehicle = null;
          root.querySelector('[data-tesla-unavailable]')?.removeAttribute('hidden');
          setStatus(root, 'Tesla vehicle detected.', 'error');
          return;
        }
        pendingVehicle = vehicle;
        if (confirmTitle) confirmTitle.textContent = [vehicle.year, vehicle.make, vehicle.model].filter(Boolean).join(' ');
        if (confirmMeta) confirmMeta.textContent = prettyRegistration(vehicle.registration);
        confirmPanel?.removeAttribute('hidden');
        setStatus(root, 'We found a vehicle. Please confirm it below.', 'success');
      } catch (error) {
        setStatus(root, 'We could not find that registration. Please check it or enter the vehicle manually.', 'error');
        openManual();
      } finally {
        if (submitButton) submitButton.disabled = false;
      }
    });

    manualForm?.addEventListener('submit', (event) => {
      event.preventDefault();
      const fd = new FormData(manualForm);
      const vehicle = {
        registration: normaliseRegistration(regInput?.value),
        make: String(fd.get('make') || '').trim(),
        model: String(fd.get('model') || '').trim(),
        derivative: String(fd.get('derivative') || '').trim(),
        generation: String(fd.get('generation') || '').trim(),
        year: String(fd.get('year') || '').trim(),
        vin: String(fd.get('vin') || '').trim().toUpperCase(),
        part_number: String(fd.get('part_number') || '').trim().toUpperCase()
      };
      if (!vehicle.make || !vehicle.model || !vehicle.year) {
        setStatus(root, 'Please enter at least make, model and year.', 'error');
        return;
      }
      if (isTesla(vehicle.make)) {
        clearSelectedVehicle();
        pendingVehicle = null;
        confirmPanel?.setAttribute('hidden', '');
        root.querySelector('[data-tesla-unavailable]')?.removeAttribute('hidden');
        setStatus(root, 'Tesla vehicle detected.', 'error');
        manualPanel?.classList.remove('is-open');
        return;
      }
      root.querySelector('[data-tesla-unavailable]')?.setAttribute('hidden', '');
      const identificationError = manualForm.querySelector('[data-identification-error]');
      if (!vehicle.vin && !vehicle.part_number) {
        if (identificationError) identificationError.hidden = false;
        manualForm.querySelector('input[name="vin"]')?.focus();
        setStatus(root, 'Please enter either your VIN or original TPMS part number.', 'error');
        return;
      }
      if (identificationError) identificationError.hidden = true;
      updateVehicleAcrossPage(vehicle);
      setStatus(root, `Vehicle selected: ${[vehicle.make, vehicle.model, vehicle.year].filter(Boolean).join(' ')}`, 'success');
      manualPanel?.classList.remove('is-open');
      document.querySelector('#kyvo-product')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // Front-end checkout safeguard. Do not submit a Tesla selection through the product form.
  document.querySelectorAll('[data-kyvo-product-form] form').forEach((productForm) => {
    productForm.addEventListener('submit', (event) => {
      const makeField = productForm.querySelector('[data-line-property="make"]');
      if (!isTesla(makeField?.value) && !isTesla(state.make)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      document.querySelector('[data-tesla-unavailable]')?.removeAttribute('hidden');
      document.querySelector('[data-vrm-section]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, true);
  });
})();
